interface TimezoneInfo {
	countryCode: string[];
}
type TimezoneMap = Record<string, TimezoneInfo>;

export const supportedRegionTimezonesForInCharge: TimezoneMap = {
	'America/New_York': { countryCode: ['US'] },
	'America/Detroit': { countryCode: ['US'] },
	'America/Indiana/Indianapolis': { countryCode: ['US'] },
	'America/Chicago': { countryCode: ['US'] },
	'America/Denver': { countryCode: ['US'] },
	'America/Phoenix': { countryCode: ['US'] },
	'America/Los_Angeles': { countryCode: ['US'] },
	'America/Boise': { countryCode: ['US'] },
	'America/Anchorage': { countryCode: ['US'] },
	'America/Juneau': { countryCode: ['US'] },
	'America/Nome': { countryCode: ['US'] },
	'Pacific/Honolulu': { countryCode: ['US'] },
	'America/Puerto_Rico': { countryCode: ['US'] },
	'America/St_Thomas': { countryCode: ['US'] },
	'Pacific/Pago_Pago': { countryCode: ['US'] },
	'Pacific/Guam': { countryCode: ['US'] },
	'Pacific/Saipan': { countryCode: ['US'] },
	'America/Adak': { countryCode: ['US'] },
	'America/Metlakatla': { countryCode: ['US'] },
	'America/Sitka': { countryCode: ['US'] },
	'America/Yakutat': { countryCode: ['US'] },
	'America/Indiana/Knox': { countryCode: ['US'] },
	'America/Indiana/Tell_City': { countryCode: ['US'] },
	'America/Menominee': { countryCode: ['US'] },
	'America/North_Dakota/Beulah': { countryCode: ['US'] },
	'America/North_Dakota/Center': { countryCode: ['US'] },
	'America/North_Dakota/New_Salem': { countryCode: ['US'] },
	'America/Indiana/Marengo': { countryCode: ['US'] },
	'America/Indiana/Petersburg': { countryCode: ['US'] },
	'America/Indiana/Vevay': { countryCode: ['US'] },
	'America/Indiana/Vincennes': { countryCode: ['US'] },
	'America/Indiana/Winamac': { countryCode: ['US'] },
	'America/Kentucky/Louisville': { countryCode: ['US'] },
	'America/Kentucky/Monticello': { countryCode: ['US'] },
	'Pacific/Wake': { countryCode: ['US'] },
	'America/Toronto': { countryCode: ['CA'] },
	'America/Ottawa': { countryCode: ['CA'] },
	'America/Montreal': { countryCode: ['CA'] },
	'America/Winnipeg': { countryCode: ['CA'] },
	'America/Regina': { countryCode: ['CA'] },
	'America/Edmonton': { countryCode: ['CA'] },
	'America/Vancouver': { countryCode: ['CA'] },
	'America/Halifax': { countryCode: ['CA'] },
	'America/St_Johns': { countryCode: ['CA'] },
	'America/Whitehorse': { countryCode: ['CA'] },
	'America/Yellowknife': { countryCode: ['CA'] },
	'America/Iqaluit': { countryCode: ['CA'] },
	'America/Rankin_Inlet': { countryCode: ['CA'] },
	'America/Resolute': { countryCode: ['CA'] },
	'America/Goose_Bay': { countryCode: ['CA'] },
	'America/Thunder_Bay': { countryCode: ['CA'] },
	'America/Swift_Current': { countryCode: ['CA'] },
	'America/Calgary': { countryCode: ['CA'] },
	'America/Inuvik': { countryCode: ['CA'] },
	'America/Creston': { countryCode: ['CA'] },
	'America/Dawson_Creek': { countryCode: ['CA'] },
	'America/Fort_Nelson': { countryCode: ['CA'] },
	'America/Nipigon': { countryCode: ['CA'] },
	'America/Pangnirtung': { countryCode: ['CA'] },
	'America/Moncton': { countryCode: ['CA'] },
	'America/Glace_Bay': { countryCode: ['CA'] },
	'America/Blanc-Sablon': { countryCode: ['CA'] },
	'America/Atikokan': { countryCode: ['CA'] },
	'America/Coral_Harbour': { countryCode: ['CA'] },
};
